<template>
    <div class="image-toggle-selection style-selection page-container">
        <div class="hero-container"
             :style="{ '--background': 'url(' + imageUrl(heroImage) + ')', '--background-2x': 'url(' + imageUrl(heroImage2x) + ')' }"
             @touchstart="dragstart"
             @touchend="dragend"
        >
            <div class="vertical-align">
                <div class="hero-hello">
                    Hey {{ user.profile_first_name }}!
                </div>
                <div class="hero-slide-title">
                    Find outfits you love, styled just for you
                </div>
                <router-link to="/get-styled" class="button">
                    Get Styled
                </router-link>
            </div>
            <router-link to="/saved-outfits" class="to-saved-outfits">
                Go To Saved Outfits
            </router-link>
        </div>
    </div>
</template>

<script>
    import SubMenu from '../common/sub-menu.vue';
    import Mixins from '../../mixins/mixins.js';
    import {mapGetters} from "vuex";
    import {LANDING_MENU_PAGES} from '../../config.js';

    export default {
        components: {
            SubMenu,
        },
        mixins: [Mixins],
        data() {
            return {
                pages: LANDING_MENU_PAGES,
                heroImage: 'landing-hero-3.jpg',
                heroImage2x: 'landing-hero-3@2x.jpg',
                dragYstart: 0,
                dragThreshold: 50
            }
        },
        computed: {
            ...mapGetters({
                user: "auth/getUser"
            }),
        },
        methods: {
            visitGetStyled() {
                this.$router.push({path: '/get-styled'});
            },
            dragstart(ev) {
                this.dragYstart = ev.touches[0].pageY;
            },
            dragend(ev) {
                if (this.dragYstart - ev.changedTouches[0].pageY > this.dragThreshold) {
                    this.$router.push({path: '/get-styled'});
                }
                this.dragYstart = 0;
            }
        },
    }
</script>

<style lang="scss" scoped>
    .hero-container {
        background-position: center;
        background-image: var(--background);
        @media screen  and (min-width: 375px) {
            background-image: var(--background-2x);    
        }
    }
</style>